// extracted by mini-css-extract-plugin
export var redoItem = "_p5-1";
export var redoTrigger = "_p5-0";